import { TokenProvider } from '~/hooks/auth/useAccessTokenProvider';
import { handleError } from '~/utils/errors';
import { BackendClient } from './backend-client';
import { APIType, MetricsTypeEnum } from './types';

export type Geometry = {
    origin: number[];
    direction: number[][];
    spacing: number[];
    size: number[];
};

export type MetricUploadType = { file: Blob; filename: string };

export class MetricsClient extends BackendClient {
    constructor(
        baseURL: string,
        tokenProvider: TokenProvider,
        sessionID: string
    ) {
        super(baseURL, tokenProvider, sessionID, APIType.METRICS);
    }

    public async submitMetrics(
        metricsType: MetricsTypeEnum,
        files: MetricUploadType[],
        groundTruthSOPInstanceUID: string,
        userFileSOPInstanceUID: string,
        geometry: Geometry
    ): Promise<boolean> {
        const data = new FormData();

        files.forEach((file_details) => {
            const { file, filename } = file_details;
            data.append('files', file, filename);
        });

        let action;

        switch (metricsType) {
            case MetricsTypeEnum.SEGMETRICS:
                action = 'segmetrics';
                break;
            case MetricsTypeEnum.DVH:
                action = 'dvh';
                break;
            case MetricsTypeEnum.GAMMAINDEX:
                action = 'gammaindex';
                break;
            default:
                throw new Error('Invalid metrics type');
        }

        try {
            // One attempt (the POST default): how the backend stores a
            // duplicate delivery of the metrics inputs cannot be verified
            // from here.
            const response = await this.request(`${this.api}/${action}`, {
                method: 'POST',
                headers: {
                    action: action,
                    scanGeometryHeader: JSON.stringify(geometry),
                    groundTruthHeader: JSON.stringify({
                        gt_file: groundTruthSOPInstanceUID,
                        user_file: userFileSOPInstanceUID,
                    }),
                    skip_dicom_validation: 'True',
                },
                buildBody: () => data,
            });
            if (response.ok) {
                return true;
            } else {
                handleError(
                    new Error('Unsuccessful response'),
                    'Server returned an unsuccessful response.'
                );
            }
        } catch (error) {
            this.reportRequestFailure(
                error,
                "Couldn't submit files succesfully."
            );
        }

        return false;
    }
}
